<template>
  <section class="row">
    <div class="col-12 col-md-9 mx-auto">
      <h5> Modifier </h5>
      <p>
        Vous pouvez valider votre modification et passer à la signature des déclarations,
        ou bien poursuivre vos modifications.
      </p>
      <v-auto-complete
        class="mt-3"
        label="Activité du local"
        placeholder="Développeur"
        :list="researchResult"
        :reset-list="resetList"
        @getlist="searchResults"
        @setitem="setActivity"
      />
    </div>
    <div class="col-12 col-md-9 mx-auto">
      <div
        class="py-2 bg-gray-300 fw-bold ps-2 text-blue-700"
        style="border-radius: 25px"
      >
        {{ contract.risk.mainActivity.name }}
      </div>
    </div>
  </section>
</template>

<script>
import { debounce } from 'lodash-es';
import { mapGetters } from 'vuex';

import { AutoComplete } from '@/components/common/input';

export default {
  name: 'LocalActivity',
  components: {
    'v-auto-complete': AutoComplete,
  },
  data() {
    return {
      debouncer: ({ cancel: () => {} }),
    };
  },
  computed: {
    ...mapGetters({
      products: 'rater/products',
      contract: 'contract/get',
      researchResult: 'activities/researchResult',
    }),
  },
  mounted() {
    this.$store.dispatch('activities/setCustomList', this.contract.grid.id);
  },
  methods: {
    searchResults(value) {
      this.debouncer.cancel();
      const setValue = () => {
        this.$store.dispatch('activities/search', { value });
      };
      this.debouncer = debounce(setValue, 500);
      this.debouncer();
    },
    setActivity(activity) {
      this.$store.dispatch('contract/updateSubscription',
        { path: 'risk.mainActivity', value: activity });
    },
    resetList() {
      this.$store.dispatch('activities/setValue', { researchResult: [] });
    },
  },
};
</script>
<style scoped>
  .fs-14 {
    font-size: 14px;
  }
</style>
